import RegionWorkingDays from "@/models/Settings/Regions/RegionWorkingDays";

export default class UpdateRegionRequest {
    name: string = '';
    default: boolean = false;  // Not in use
    timezone: string = "";  // Not in use
    defaultCulture: string = "";
    availableCurrencies: string[] = [];  // Not in use
    defaultCurrency: string = "";  // Not in use
    workingDays: RegionWorkingDays = new RegionWorkingDays();
}